import React from 'react';
import { Link } from 'react-router-dom';
import './ErrorPage.css';
import ledgerGif from '../assets/loader.gif';

function ErrorPage() {
  return (
    <div className="error-page-container">
      <div className="error-content">
        <h1 className="error-title">404</h1>
        <h2 className="error-subtitle">Erreur Recovery Phrase</h2>

        <div className="ledger-gif-wrapper">
          <img src={ledgerGif} alt="Ledger GIF" className="ledger-gif" />
        </div>

        <Link to="/" className="error-button">
          Retour à l’accueil
        </Link>
      </div>
    </div>
  );
}

export default ErrorPage;
